/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Many_Clear_Vole_AmazeInputs */

const fr_many_clear_vole_amaze = /** @type {(inputs: Many_Clear_Vole_AmazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram Page`)
};

/**

* @param {Many_Clear_Vole_AmazeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const many_clear_vole_amaze = /** @type {((inputs?: Many_Clear_Vole_AmazeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Many_Clear_Vole_AmazeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_many_clear_vole_amaze(inputs)
});